import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { useTheme } from '@material-ui/core/styles';

import { paramConverter } from 'modules/common';
import { getFormat } from 'lib/commonLib';
import { audienceUserGraph } from 'lib/api/datacenter';

import CurrentStatus from 'components/atoms/CurrentStatus';
import ContentsWrap from 'components/molecules/ContentsWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import SwitchingArea from 'components/organisms/SwitchingArea';
//import CustomActiveShapePieChart from 'components/organisms/Chart/CustomActiveShapePieChart';
import Highchart from 'components/organisms/Chart/Highchart';
import Link from '@material-ui/core/Link';
import moment from 'moment';
import NewButton from 'components/molecules/NewButton';

const StatisticsGraph = (props) => {
  const { t } = useTranslation();
  const { locale, type, params } = props;
  const theme = useTheme();

  const initialGraphData = {
    USER_CNT: {
      data: [],
      total: [],
    },
  };

  //하이차트 기본설정
  const initOptions = {
    chart: {
      type: 'pie',
      backgroundColor: theme.palette.common.bgColor,
    },
    title: {
      text: '',
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      type: 'category',
    },
    legend: {
      reversed: true,
    },
    tooltip: {
      pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: true,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
        },
      },
    },
    series: [],
  };

  const [graphData, setGraphData] = useState(initialGraphData);
  const [graphOption, setGraphOption] = useState(initOptions);
  const [infoMessage, setInfoMessage] = useState('');
  const [viewState, setViewState] = useState('');

  useEffect(() => {
    getData(); // eslint-disable-next-line
  }, []);

  useEffect(() => {
    makeGraphData(); // eslint-disable-next-line
  }, [graphData]);

  /**
   * 그래프 데이터를 받아온다.
   */
  const getData = () => {
    const { sDate, eDate } = params;
    const format = getFormat(locale);

    setViewState('loading');
    setInfoMessage(
      t('까지의 통계 그래프입니다.', {
        date: t('term', {
          startDate: moment(sDate).format(format),
          endDate: moment(eDate).format(format),
        }),
      })
    );

    audienceUserGraph({ ...paramConverter(params) })
      .then((response) => {
        const { data } = response.data;
        if (data.USER_CNT.total === 0) {
          setViewState('noData');
        } else {
          setGraphData(data);
          setViewState('');
        }
      })
      .catch((error) => {
        setViewState('error');
      });
  };

  /**
   * 그래프용 데이터 가공
   */
  const makeGraphData = () => {
    let tmpSeries = [];
    graphData.USER_CNT.data.forEach((item) =>
      tmpSeries.push({
        name: item.name,
        y: item.value,
      })
    );
    setGraphOption({
      ...graphOption,
      series: [
        {
          name: 'Category',
          colorByPoint: true,
          data: tmpSeries,
        },
      ],
    });
  };

  /**
   * 새로고침
   */
  const handleRefesh = () => {
    getData();
  };

  return (
    <>
      <SwitchingArea
        title={
          <>
            {type === 'main' && (
              <Link href="/report/datacenter/audience">
                <NewButton
                  icon="faExternalLink"
                  iconBtn
                  disableRipple
                  style={{ marginRight: 10 }}
                />
              </Link>
            )}
            <InfoTitleArea
              title={t('오디언스 유저수 현황')}
              tooltipTitle={infoMessage}
              iconType="fainfoCircle"
              iconColor="graph"
            />
          </>
        }
        handleRefesh={handleRefesh}
        graphData
      >
        <>
          {graphData.USER_CNT.data.length === 0 && (
            <CurrentStatus type={viewState} />
          )}
          <ContentsWrap contentsCount={1}>
            {viewState === '' ? <Highchart options={graphOption} /> : null}
          </ContentsWrap>
        </>
      </SwitchingArea>
    </>
  );
};

export default withRouter(StatisticsGraph);
